import React from "react"

function IconUpload() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" viewBox="0 0 97 97">
      <path fill="#000" d="M52.541 76.792V60.625h12.125L48.5 40.417 32.333 60.625h12.125v16.167h8.083z"></path>
      <path
        fill="#000"
        d="M28.291 76.792h8.084v-8.084H28.29c-6.685 0-12.125-5.44-12.125-12.125 0-5.674 4.846-11.139 10.804-12.185l2.348-.413.776-2.255c2.841-8.29 9.898-13.438 18.406-13.438 11.143 0 20.208 9.065 20.208 20.208v4.042h4.042c4.458 0 8.083 3.625 8.083 8.083s-3.625 8.083-8.083 8.083H60.625v8.084H72.75c8.916 0 16.166-7.251 16.166-16.167a16.208 16.208 0 00-12.351-15.714C74.799 31 62.888 20.208 48.5 20.208c-11.14 0-20.815 6.511-25.232 16.773-8.682 2.595-15.185 10.791-15.185 19.602 0 11.143 9.065 20.209 20.208 20.209z"
      ></path>
    </svg>
  )
}

export default IconUpload
